import { render } from "./customer-information.vue?vue&type=template&id=328f209b"
import script from "./customer-information.vue?vue&type=script&lang=js"
export * from "./customer-information.vue?vue&type=script&lang=js"
script.render = render

export default script